import { ProductGroups } from 'enums';
import _ from 'lodash';
import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

interface PricingStore {
  activePricing: ProductGroups;

  setActivePricing: (newActivePricing: ProductGroups) => void;
}

const storedPricing = localStorage.getItem('active-pricing') as ProductGroups;

const usePaymentStore = createWithEqualityFn<PricingStore>((set) => ({
  activePricing: !_.isNil(storedPricing) ? storedPricing : ProductGroups.HR_BOOSTER,

  setActivePricing(newActivePricing: ProductGroups) {
    set(() => ({ activePricing: newActivePricing }));

    if (!_.isNil(newActivePricing)) {
      localStorage.setItem('active-pricing', newActivePricing);
    } else {
      localStorage.removeItem('active-pricing');
    }
  },
}), shallow);

export default usePaymentStore;
